import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4),
    backgroundColor: theme.colorPalette.green_100,
    marginBottom: theme.spacing(4),
    ...reskinStyles(theme, { border: 'none' })
  },
  errorCard: {
    backgroundColor: theme.colorPalette.red_100
  },
  label: {
    display: 'contents',
    fontWeight: 400
  },
  button: {
    width: 180,
    padding: theme.spacing(3, 4),
    display: 'flex',
    '& > span': {
      fontSize: 12,
      fontWeight: 600
    },
    // Reskin: a white link button, like the alternate payment method link, so its hover reads on red and green.
    ...reskinStyles(theme, {
      '&&': { backgroundColor: 'transparent', borderRadius: 22 },
      '&&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.16)' },
      '& > span': { fontSize: 12, fontWeight: 600, color: theme.colorPalette.white, textDecoration: 'underline' },
      '& img': { filter: 'brightness(0) invert(1)' }
    })
  },
  chevronRightIcon: {
    marginLeft: theme.spacing(2)
  }
}));

export default useStyles;
